import {GetStreamResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  EmptyState,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  Text,
  desktopAndUp,
  tabletAndDown,
  tabletAndUp,
} from '@aboutyou/ui-components';
import React, {useEffect} from 'react';
import styled, {css} from 'styled-components';
import {usePotentialFilters} from '../../../../features/ProductStream/utils';

const getErrorValues = (data: GetStreamResponse) => {
  if (!data?.items?.length) {
    return null;
  }

  const item = data.items[0];

  switch (item?.type?.$case) {
    case 'expired':
      return item.type.expired;
    case 'empty':
      return item.type.empty;
  }
};

const getErrorType = (data: GetStreamResponse) => {
  if (!data?.items?.length) {
    return null;
  }

  const item = data.items[0];

  switch (item?.type?.$case) {
    case 'expired':
      return 'expired';
    case 'empty':
      return 'empty';
  }
};

export const StreamEmpty = ({
  requestData,
}: {
  requestData: GetStreamResponse;
}) => {
  const {t} = useTranslation();
  const error = getErrorValues(requestData);
  const errorType = getErrorType(requestData);

  const {resetFilters, filters} = usePotentialFilters();

  useEffect(() => {
    if (errorType === 'empty') {
      resetFilters(
        Array.from(filters.keys()).filter(
          key => key !== 'categoryId' && key !== 'gender',
        ),
      );
    }
  }, [errorType, filters, resetFilters]);

  if (!error) {
    return null;
  }

  return (
    <StyledEmptyState
      data-testid="CouponProductStreamEmpty"
      asset={
        errorType === 'empty' ? (
          <IconWrapper asset={GenericIconName.EmptySearch} />
        ) : (
          <IconPositionWrapper>
            <StyledIcon asset={GenericIconName.CouponExpired} />
          </IconPositionWrapper>
        )
      }
      title={<StyledHeading as="h1">{error.headline}</StyledHeading>}
      subtitle={t(error.subline)}
      cta={
        <Button
          variant="secondary"
          href={error.primaryCta?.link.linkTarget.url}
          openExternalLinkInNewTab={error.primaryCta?.link.linkTarget.external}
          aria-label={undefined}
        >
          {error.primaryCta?.link.label}
        </Button>
      }
    />
  );
};

const IconPositionWrapper = styled.div`
  display: flex;

  ${tabletAndDown(css`
    height: 72px;
    margin-top: 4rem;
  `)}
`;

const IconWrapper = styled(Icon)`
  width: 110px;
  height: 160px;
  flex-basis: 85px;
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.04), 0 -2px 4px 0 rgba(0, 0, 0, 0.02);
`;

const StyledHeading = styled(Text)`
  font-weight: ${FONT_WEIGHTS.bold};
  font-size: ${FONT_SIZES.px20};

  ${tabletAndUp(css`
    font-size: ${FONT_SIZES.px24};
  `)}
`;

const StyledIcon = styled(Icon)`
  ${desktopAndUp(css`
    width: 120px;
    height: 120px;
  `)}
`;

const StyledEmptyState = styled(EmptyState)`
  ${desktopAndUp(css`
    justify-content: center;
    align-items: center;
    padding-top: 10rem;
  `)}
`;
